import axios, {AxiosResponse} from 'axios'

// List course
const courseList = async ({params}) => {
  const response = await axios.get('/api/course/list', params)
  return response.data
}

// Create Or Update new course
const courseCreate = async ({data}) => {
  await axios.post('/api/course/store', data)
}

// Edit course
const courseEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/course/edit/${id}`)
  return response.data
}

// Delete course
const courseDelete = async (id: string) => {
  await axios.get(`/api/course/destroy/${id}`)
}

// View course
const courseView = async (id: string) => {
  const response = await axios.get(`/api/course/view/${id}`)
  return response.data
}

// List courseLesson
const courseLessonList = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/course-lesson/list/${id}`)
  return response.data
}

// List courseLesson
const courseLessonBySessionList = async (
  id: string,
  lesson_number: number
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/course-lesson/list-by-lesson/${id}/${lesson_number}`)
  return response.data
}

// Create Or Update new courseLesson
const courseLessonCreate = async ({data}) => {
  await axios.post('/api/course-lesson/store', data)
}

// Delete courseLesson
const courseLessonDelete = async (id: string) => {
  await axios.get(`/api/course-lesson/destroy/${id}`)
}

// Toggle View courseLesson
const courseLessonToggleView = async (id: string) => {
  await axios.get(`/api/course-lesson/toggle-visibility/${id}`)
}

// List publicationCategory
const publicationCategoryList = async ({params}) => {
  const response = await axios.get('/api/publication-category/list', params)
  return response.data
}

// Create Or Update new publicationCategory
const publicationCategoryCreate = async ({data}) => {
  await axios.post('/api/publication-category/store', data)
}

// Edit publicationCategory
const publicationCategoryEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/publication-category/edit/${id}`)
  return response.data
}

// Delete publicationCategory
const publicationCategoryDelete = async (id: string) => {
  await axios.get(`/api/publication-category/destroy/${id}`)
}

// List publicationField
const publicationFieldList = async ({params}) => {
  const response = await axios.get('/api/publication-field/list', params)
  return response.data
}

// Create Or Update new publicationField
const publicationFieldCreate = async ({data}) => {
  await axios.post('/api/publication-field/store', data)
}

// Edit publicationField
const publicationFieldEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/publication-field/edit/${id}`)
  return response.data
}

// Delete publicationField
const publicationFieldDelete = async (id: string) => {
  await axios.get(`/api/publication-field/destroy/${id}`)
}

// List CampusFaculty
const campusFacultyList = async ({params}) => {
  const response = await axios.get('/api/campus-faculty/list', params)
  return response.data
}

// Create Or Update new CampusFaculty
const campusFacultyCreate = async ({data}) => {
  await axios.post('/api/campus-faculty/store', data)
}

// Edit CampusFaculty
const campusFacultyEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus-faculty/edit/${id}`)
  return response.data
}

// Delete CampusFaculty
const campusFacultyDelete = async (id: string) => {
  await axios.get(`/api/campus-faculty/destroy/${id}`)
}

// List CampusDepartment
const campusDepartmentList = async ({params}) => {
  const response = await axios.get('/api/campus-department/list', params)
  return response.data
}

// Create Or Update new CampusDepartment
const campusDepartmentCreate = async ({data}) => {
  await axios.post('/api/campus-department/store', data)
}

// Edit CampusDepartment
const campusDepartmentEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/campus-department/edit/${id}`)
  return response.data
}

// Delete CampusDepartment
const campusDepartmentDelete = async (id: string) => {
  await axios.get(`/api/campus-department/destroy/${id}`)
}

// List publication
const publicationList = async ({params}) => {
  const response = await axios.get('/api/publication/list', params)
  return response.data
}

// Create Or Update publication
const publicationCreate = async ({data}) => {
  await axios.post('/api/publication/store', data)
}

// Edit publication
const publicationEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/publication/edit/${id}`)
  return response.data
}

// Delete publication
const publicationDelete = async (id: string) => {
  await axios.get(`/api/publication/destroy/${id}`)
}

// Get Authors
const getAuthors = async (type: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/publication/get-author/${type}`)
  return response.data
}

// publicationToggle
const publicationToggle = async (id: string) => {
  await axios.get(`/api/publication/toggle/${id}`)
}

// publicationRating
const publicationRating = async (id: string, rate: string) => {
  await axios.get(`/api/publication/rating/${id}/${rate}`)
}

// List videoLibrary
const videoLibraryList = async ({params}) => {
  const response = await axios.get('/api/video-library/list', params)
  return response.data
}

// Create Or Update videoLibrary
const videoLibraryCreate = async ({data}) => {
  await axios.post('/api/video-library/store', data)
}

// Edit videoLibrary
const videoLibraryEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/video-library/edit/${id}`)
  return response.data
}

// Delete videoLibrary
const videoLibraryDelete = async (id: string) => {
  await axios.get(`/api/video-library/destroy/${id}`)
}

// videoLibraryToggle
const videoLibraryToggle = async (id: string) => {
  await axios.get(`/api/video-library/toggle/${id}`)
}

// emailToRelatedStudents
const relatedStudentsEmail = async ({data}) => {
  await axios.post('/api/campus-faculty/email', data)
}

const timeTableList = async (lang: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/list/${lang}`)
  return response.data
}

const timeTableCourseDelete = async (id: string) => {
  await axios.get(`/api/timetable/destroy-course/${id}`)
}

const timeTableCourseCreate = async ({data}) => {
  await axios.post('/api/timetable/store-course', data)
}

const timeTableCourseEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/edit-course/${id}`)
  return response.data
}

const timeTableProgramDelete = async (id: string) => {
  await axios.get(`/api/timetable/destroy-program/${id}`)
}

const timeTableProgramCreate = async ({data}) => {
  await axios.post('/api/timetable/store-program', data)
}

const timeTableProgramEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/edit-program/${id}`)
  return response.data
}

const timeTableSemesterDelete = async (id: string) => {
  await axios.get(`/api/timetable/destroy-semester/${id}`)
}

const timeTableSemesterCreate = async ({data}) => {
  await axios.post('/api/timetable/store-semester', data)
}

const timeTableSemesterEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/edit-semester/${id}`)
  return response.data
}

const timeTableScheduleDelete = async (id: string) => {
  await axios.get(`/api/timetable/destroy-schedule/${id}`)
}

const timeTableScheduleCreate = async ({data}) => {
  const res = await axios.post('/api/timetable/store-schedule', data)
  return res.data
}

const timeTableScheduleEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/edit-schedule/${id}`)
  return response.data
}

const courseToggle = async (id: string) => {
  await axios.get(`/api/timetable/toggle/${id}`)
}

const programToggle = async (id: string) => {
  await axios.get(`/api/timetable/program-toggle/${id}`)
}

const addStudent = async ({data}) => {
  await axios.post('/api/timetable/add-student', data)
}

const courseStudentsList = async (
  targetType: string,
  targetId: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/stduents-list/${targetType}/${targetId}`)
  return response.data
}

const courseStudentDelete = async (id: string) => {
  await axios.get(`/api/timetable/destroy/${id}`)
}

const courseStudentsDelete = async ({data}) => {
  const res = await axios.post(`/api/timetable/destroy-course-students`, data)
  return res.data
}

const getLecturers = async () => {
  const response = await axios.get(`/api/timetable/get-lecturers`)
  return response.data
}

const printTimeTable = async (id: string) => {
  const response = await axios.get(`/api/timetable/print/${id}`)
  return response.data
}

const approveStudentScore = async (
  targetType: string,
  targetId: string
): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/approve-score/${targetType}/${targetId}`)
  return response.data
}

const attReportPrint = async (courseId: string, type: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/att-print/${courseId}/${type}`)
  return response.data
}

const courseEvReport = async (tarId: string, tarType: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/timetable/course-ev-report/${tarId}/${tarType}`)
  return response.data
}

const updateTimeSlot = async ({data}) => {
  await axios.post('/api/timetable/update-timeslot', data)
}

const getAyStudents = async (id: string) => {
  const response = await axios.get(`/api/timetable/get-ay-stds/${id}`)
  return response.data
}

const getAyProStds = async ({data}) => {
  const res = await axios.post('/api/timetable/get-pro-ay-stds', data)
  return res.data
}

const createTimeSlot = async ({data}) => {
  await axios.post('/api/timetable/timeslot-create', data)
}

const academicService = {
  createTimeSlot,
  getAyProStds,
  getAyStudents,
  updateTimeSlot,
  courseEvReport,
  attReportPrint,
  approveStudentScore,
  printTimeTable,
  getLecturers,
  courseStudentDelete,
  courseStudentsDelete,
  courseStudentsList,
  addStudent,
  courseLessonBySessionList,
  courseToggle,
  programToggle,
  timeTableScheduleDelete,
  timeTableScheduleCreate,
  timeTableScheduleEdit,
  timeTableSemesterDelete,
  timeTableSemesterCreate,
  timeTableSemesterEdit,
  timeTableProgramEdit,
  timeTableProgramCreate,
  courseList,
  courseCreate,
  courseEdit,
  courseDelete,
  courseView,
  courseLessonList,
  courseLessonCreate,
  courseLessonDelete,
  courseLessonToggleView,
  publicationCategoryList,
  publicationCategoryCreate,
  publicationCategoryEdit,
  publicationCategoryDelete,
  publicationFieldList,
  publicationFieldCreate,
  publicationFieldEdit,
  publicationFieldDelete,
  campusFacultyList,
  campusFacultyCreate,
  campusFacultyEdit,
  campusFacultyDelete,
  campusDepartmentList,
  campusDepartmentCreate,
  campusDepartmentEdit,
  campusDepartmentDelete,
  publicationList,
  publicationCreate,
  publicationEdit,
  publicationDelete,
  getAuthors,
  publicationToggle,
  publicationRating,
  videoLibraryList,
  videoLibraryCreate,
  videoLibraryEdit,
  videoLibraryDelete,
  videoLibraryToggle,
  relatedStudentsEmail,
  timeTableList,
  timeTableCourseDelete,
  timeTableCourseCreate,
  timeTableCourseEdit,
  timeTableProgramDelete,
}

export default academicService
